// Smit: 24-11

export const SET_ERROR = "SET_ERROR";
export const SET_SUCCESS = "SET_SUCCESS";
